<template>
  <div v-if="visible">
    <transition name="el-fade-in" @after-leave="handleAfterLeave">
      <div class="NoticeListDialog" v-show="isActived">
        <div class="NoticeListDialog-box">
          <div class="NoticeListDialog-cover"></div>
          <div class="NoticeListDialog-content-box">
            <div class="NoticeListDialog-content">
              <img :src="activeNotice && activeNotice.picturePath" @click.stop="toFour" style="cursor: pointer" />
              <div class="check-title" @click="chooseNoMore">
                <div v-if="!isChoosed" class="NoticeListDialog-nocketBtn"></div>
                <img v-else src="https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/home/choose.png" />
                <span class="noLongerPopUp">不再弹出</span>
              </div>
              <div class="btn" @click="handleIKnow">我知道了</div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<!-- 公告弹框 -->
<script>
import { fetchNoticeList, noMoreShowNotice } from '@/api/user'

export default {
  name: 'NoticeListDialog',
  data() {
    return {
      visible: true,
      isActived: false,
      isChoosed: false,
      notices: [],
      activeIndex: 0
    }
  },
  computed: {
    activeNotice() {
      return this.notices[this.activeIndex]
    }
  },
  async mounted() {
    this.getList()
  },
  methods: {
    toFour() {
      if (location.pathname == '/introduce/four') {
        this.handleIKnow()
      } else {
        location.href = window.location.origin + '/introduce/four'
      }
    },

    // 获取通知列表
    async getList() {
      const res = await fetchNoticeList()
      let list = []
      if (res.success) {
        res.data.forEach(v => {
          if (v.picturePath.indexOf('http') < 0) {
            v.picturePath = '//' + v.picturePath
          }
        })
        list = res.data
      }

      if (list.length < 1) return
      this.notices = list
      this.visible = true
      this.isActived = true
    },

    chooseNoMore() {
      this.isChoosed = !this.isChoosed
    },

    handleAfterLeave() {
      let { activeIndex, notices } = this
      // 如果当前是最后一条公告，则关闭弹框
      if (activeIndex >= notices.length - 1) {
        this.visible = false
        this.notices = []
        this.activeIndex = 0
        return
      }
      this.activeIndex++
      this.isChoosed = false
      this.isActived = true
    },

    handleIKnow() {
      let { isChoosed, activeNotice } = this
      if (isChoosed) {
        let { noticeId } = activeNotice
        noMoreShowNotice(noticeId)
      }

      this.isActived = false
    }
  }
}
</script>

<style lang="scss" scoped>
.NoticeListDialog {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 101;
  .NoticeListDialog-box {
    position: relative;
    width: 100%;
    height: 100%;
    .NoticeListDialog-cover {
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.6);
    }
    .NoticeListDialog-content-box {
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%);
      top: 50%;
      .NoticeListDialog-content {
        text-align: center;

        .check-title {
          margin-top: -30px;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 14px;
            height: 14px;
          }
        }
        .btn {
          width: 228px;
          height: 46px;
          background: #3987fe;
          border-radius: 23px;
          color: #fff;
          display: inline-block;
          line-height: 46px;
          margin-top: 30px;
          cursor: pointer;
        }
        .noLongerPopUp {
          font-size: 12px;
          margin-left: 6px;
        }
        .NoticeListDialog-nocketBtn {
          width: 12px;
          height: 12px;
          background: #ffffff;
          border-radius: 1px;
          border: 1px solid rgba(0, 0, 0, 0.15);
          display: inline-block;
          background-image: none;
          background-position: center left;
          background-size: 14px;
          background-repeat: no-repeat;
        }
        .NoticeListDialog-btn1 {
        }
        .NoticeListDialog-btn2 {
          position: absolute;
          left: 50%;
          margin-left: -206px;
          bottom: 32px;
          width: 412px;
          height: 64px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
